import React, { useEffect } from "react";
import { Container } from "react-bootstrap";
import List from "./list";

export default function UsersIndex() {


    useEffect(() => {
        //eslint-disable-next-line
    }, []);

    return (
        <Container className="component-container">
            <List />
        </Container>
    )
};